import styled, { css } from 'styled-components';

export const Box = styled.div<{ $disableSelection: boolean }>`
  position: relative;

  ${({ $disableSelection }) =>
    $disableSelection &&
    css`
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    `}
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  background-color: transparent;
`;
